import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { compact, map } from 'lodash'
import routes from '../routes/routes'
import confirmService from '../services/confirm.service'
import alertService from '../services/alert.service'
import contactApi, { ContactUpdateRequest } from '../apis/contact.api'
import { ConfirmParams } from '../components/Confirm/Confirm.state'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import Card from '../components/Card'
import CardButton from '../components/CardButton'
import Row from '../components/Row/Row'
import InputText from '../components/InputText'
import PageHeading from '../components/PageHeading'
import ContactSiteInput, {
  ContactSiteInputSite
} from '../components/ContactSiteInput'

interface ContactEditRouteState {
  id: number
}

interface ContactEditProps
  extends RouteComponentProps<any, any, ContactEditRouteState> {}

interface ContactEditState {
  sitesExisting: ContactSiteInputSite[]
  sitesCreated: ContactSiteInputSite[]
  sitesUpdated: ContactSiteInputSite[]
  sitesDeleted: ContactSiteInputSite[]
  name: string
}

class ContactEdit extends Component<ContactEditProps, ContactEditState> {
  constructor (props: ContactEditProps) {
    super(props)
    this.state = {
      sitesExisting: [],
      sitesCreated: [],
      sitesUpdated: [],
      sitesDeleted: [],
      name: ''
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSitesCreatedChange = this.handleSitesCreatedChange.bind(this)
    this.handleSitesUpdatedChange = this.handleSitesUpdatedChange.bind(this)
    this.handleSitesDeletedChange = this.handleSitesDeletedChange.bind(this)
    this.handleSaveClick = this.handleSaveClick.bind(this)
  }

  get id () {
    return this.props.location.state.id
  }

  save () {
    const { name, sitesCreated, sitesUpdated, sitesDeleted } = this.state
    const payload: ContactUpdateRequest = {}
    if (name) payload.name = name
    if (sitesCreated) payload.sitesCreated = sitesCreated
    if (sitesUpdated) payload.sitesUpdated = sitesUpdated
    if (sitesDeleted) payload.sitesDeleted = map(sitesDeleted, 'id')
    contactApi.update(this.id, payload, contact => {
      if (!contact) return
      alertService.success('Successfully updated contact')
      this.props.history.push(routes.contacts)
    })
  }

  handleInputChange (name: string, value: string) {
    if (name === 'name') this.setState({ name: value })
  }

  handleSaveClick () {
    const confirm: ConfirmParams = {
      id: 1,
      question: i18n('Please review the contact details above and then confirm'),
      confirmText: i18n('Confirm'),
      cancelText: i18n('Cancel'),
      onConfirm: () => this.save()
    }
    confirmService.push(confirm)
  }

  readContact () {
    contactApi.read(this.id, contact => {
      if (!contact || !contact.contactable) return
      const { name } = contact.contactable
      const sites = map(contact.sites, site => {
        if (!site.address) return null
        const { id, name } = site
        const { address, city, state, zip } = site.address
        return { id, name, address, city, state, zip }
      })
      this.setState({ name, sitesExisting: compact(sites) })
    })
  }

  handleSitesCreatedChange (sitesCreated: ContactSiteInputSite[]) {
    this.setState({ sitesCreated })
  }

  handleSitesUpdatedChange (sitesUpdated: ContactSiteInputSite[]) {
    this.setState({ sitesUpdated })
  }

  handleSitesDeletedChange (sitesDeleted: ContactSiteInputSite[]) {
    this.setState({ sitesDeleted })
  }

  componentDidMount () {
    this.readContact()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="twoThird">
          <Card>
            <PageHeading
              text={i18n("Edit Contact")}
              doc='contacts-edit-contact' />
            <Row column={2}>
              <InputText
                name="name"
                value={this.state.name}
                label={i18n("Contact global name")}
                onChange={this.handleInputChange} />
            </Row>
            <ContactSiteInput
              sitesExisting={this.state.sitesExisting}
              sitesCreated={this.state.sitesCreated}
              sitesUpdated={this.state.sitesUpdated}
              sitesDeleted={this.state.sitesDeleted}
              onSitesCreatedChange={this.handleSitesCreatedChange}
              onSitesUpdatedChange={this.handleSitesUpdatedChange}
              onSitesDeletedChange={this.handleSitesDeletedChange} />
            <CardButton
              proceedText={i18n("Save")}
              cancelText={i18n("Cancel")}
              onProceedClick={this.handleSaveClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

export default withRouter(ContactEdit)
